export interface IApproveReject {
  response: string | null;
  registration_id: string | null;
  commencement_date: Date | null;
  registration_date: Date | null;
  comments: string | null;
}

interface IDefaultValues {
  registration_id: string;
  commencement_date?: Date;
  registration_date?: Date;
}

export function handleApproveRejectDefaultValues(
  body: IDefaultValues
): IApproveReject {
  return {
    response: null,
    registration_id: body.registration_id,
    commencement_date: body.commencement_date ?? null,
    registration_date: body.registration_date ?? null,
    comments: null,
  };
}
